module.exports = __webpack_public_path__ + "static/media/sf_restaurant_10.59c95ae9.jpg";